import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { PlayCircleOutline, Download, FolderZip, PlaylistAdd, Delete } from '@mui/icons-material';
import { useFilePlayerContext } from '../FilePlayerContext';
import { useZipDownload } from '../hooks/useZipDownload';
import { AddToPlaylistDialog } from './AddToPlaylistDialog';

export const FileActionBar = () => {
  const { fileSelection } = useFilePlayerContext();
  const {
    selectedCount = 0,
    clearAll,
    checkedItems,
    selectedPurchasedItemIds,
  } = fileSelection;

  const { startZipDownload } = useZipDownload();
  const [showPlaylistDialog, setShowPlaylistDialog] = useState(false);

  if (selectedCount === 0) return null;

  const handleZip = () => {
    startZipDownload({ checkedItems });
    clearAll();
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'grey.200',
          padding: 1,
          borderRadius: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={clearAll}>
            <span>&lt;</span>
          </IconButton>
          <Typography variant="body1" sx={{ ml: 1 }}>
            {`${selectedCount} selected`}
          </Typography>
        </Box>

        <Box>
          <IconButton>
            <PlayCircleOutline />
          </IconButton>
          {selectedCount === 1 && (
            <IconButton>
              <Download />
            </IconButton>
          )}
          {selectedCount > 1 && (
            <IconButton onClick={handleZip}>
              <FolderZip />
            </IconButton>
          )}
          <IconButton onClick={() => setShowPlaylistDialog(true)}>
            <PlaylistAdd />
          </IconButton>
          <IconButton>
            <Delete />
          </IconButton>
        </Box>
      </Box>

      <AddToPlaylistDialog
        open={showPlaylistDialog}
        onClose={() => setShowPlaylistDialog(false)}
        purchasedItemIds={selectedPurchasedItemIds}
      />
    </>
  );
};
